import { createSlice } from "@reduxjs/toolkit";

const timeSheetSlice = createSlice({
    name: "timeSheet",
    initialState: {
        isLoading: false,
        employeeList: [],
        projectList: [],
        taskList: [],
        roleList: [],
        project: {},
        taskPagination: [],
        employeeRoleMappingPagination: [],
        employeePaginationByRole: [],
        projectWorkflow: {}
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setEmployeeList(state, action) {
            state.employeeList = action.payload;
        },
        setProjectList(state, action) {
            state.projectList = action.payload;
        },
        setTaskList(state, action) {
            state.taskList = action.payload;
        },
        setRoleList(state, action) {
            state.roleList = action.payload;
        },
        setProject(state, action) {
            state.project = action.payload;
        },
        setTaskPagination(state, action) {
            state.taskPagination = action.payload;
        },
        setEmployeeRoleMappingPagination(state, action) {
            state.employeeRoleMappingPagination = action.payload;
        },
        setEmployeePaginationByRole(state, action) {
            state.employeePaginationByRole = action.payload;
        },
        setProjectWorkflow(state, action) {
            state.projectWorkflow = action.payload;
        },
    },
});

export const { setIsLoading, setEmployeeList, setProjectList, setProject, setTaskList, setRoleList, setTaskPagination, setEmployeeRoleMappingPagination, setEmployeePaginationByRole, setProjectWorkflow } = timeSheetSlice.actions;
export default timeSheetSlice.reducer;